import {observer} from "mobx-react";
import {Action, Page, PageContentTitle} from "../../ui";
import {fmsShippingClientListStore, fmsShippingConfigStore} from "../../../store";
import {FmsShippingClientList} from "./FmsShippingClientList";
import {useNavigate} from "react-router";
import {FmsShippingConfigurationTab} from "./FmsShippingConfigurationTab";
import {PageContentTitleAction} from "@kroschke/react-ui/dist/components/PageContentTitle";

export type Tabs = '' | 'config'

const FmsShippingManagementPage = observer(function FmsShippingManagementPage({
    tab
                                                                              }: {
    tab?: Tabs
}) {
    const navigate = useNavigate()

    const actions: Action[] = []
    const titleActions: PageContentTitleAction[] = []

    if (!tab) {
        actions.push({
            label: 'Neuen Mandanten registrieren',
            icon: 'delivery_truck_speed',
            action: () => navigate('/fms/shippingclient/create')
        })
    }

    if (tab === 'config') {
        titleActions.push({
            label: 'Speichern',
            cls: 'is-primary',
            disabled: !fmsShippingConfigStore.savable,
            action: () => fmsShippingConfigStore.save()
        })
    }

    return <Page
        breadcrumb={[
            {
                link: !tab ?  '/fms/shippingclient': '/fms/shippingconfig',
                label:  'Versandverwaltung'
            }
        ]}
        actions={actions}
    >
        <PageContentTitle
            actions={titleActions}
        >
            <div style={{display: "flex"}}>
                <div style={{paddingRight: '1em'}}>
                    <button className={`button is-rounded is-small is-info ${!tab ? '' : 'is-outlined'}`}
                            onClick={() => {
                                if (tab) {
                                    navigate('/fms/shippingclient')
                                }
                            }}>Mandanten
                    </button>
                </div>
                <div style={{paddingRight: '1em'}}>
                    <button className={`button is-rounded is-small is-info ${tab === 'config' ? '' : 'is-outlined'}`}
                            onClick={() => {
                                if (tab !== 'config') {
                                    navigate('/fms/shippingconfig')
                                }
                            }}>Standardmandaten
                    </button>
                </div>
            </div>
        </PageContentTitle>
        {!tab  && <FmsShippingClientList pages={fmsShippingClientListStore.pages} items={fmsShippingClientListStore.items} />}
        {tab === 'config'  && <FmsShippingConfigurationTab />}
    </Page>
})

export {
    FmsShippingManagementPage
}
